//clickStatefrom.js文件
export default {
	install(Vue) {
		// 防止重复点击
		Vue.directive('preventClick', {
			inserted(el, binding) {
				el.addEventListener('click', () => {
					if (!el.disabled) {
						el.disabled = true
						setTimeout(() => {
							el.disabled = false
						}, 1500)
					}
					if (el.style.pointerEvents == '') {
						el.style.pointerEvents = 'none'; // 防止a标签
						setTimeout(() => {
							el.style.pointerEvents = '';
						}, 1500);
					}
				})
			}
		})
	}
}